import React from 'react'
import PropTypes from 'prop-types'
import { logError } from 'tools/logging'

class RootErrorBoundary extends React.Component {
  state = {
    hasError: false,
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true })
    logError(`Error Caught By Root Boundary: ${error.message}`)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ color: 'white', padding: '24px 8px' }}>
          There was an error loading the site header. Please refresh this page, and contact customer service if the
          problem persists.
        </div>
      )
    }
    return this.props.children
  }
}

RootErrorBoundary.propTypes = {
  children: PropTypes.element.isRequired,
}

export default RootErrorBoundary



// WEBPACK FOOTER //
// ./src/atoms/RootErrorBoundary/RootErrorBoundary.js